module.exports = __webpack_public_path__ + "img/List.356732a9.svg";